/* Customer photos strip for the Judge.me review widget (Mara's audit fix). Loaded on product pages only (layout/theme.liquid). Styles in custom.css. */
(function () {
  'use strict';
  const PER_PAGE = 25;
  const MAX_PAGES = 20;
  const WIDGET_SELECTOR = '.jdgm-widget.jdgm-review-widget[data-product-id]';
  const STRIP_CLASS = 'review-photos';

  function shopDomain() {
    if (window.jdgm && typeof window.jdgm.shopDomain === 'function') return window.jdgm.shopDomain();
    return window.Shopify && window.Shopify.shop;
  }
  function sizedUrl(url, width) {
    try { const u = new URL(url); u.searchParams.set('width', width); return u.toString(); } catch (e) { return url; }
  }
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function parseReviews(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const reviews = [...doc.querySelectorAll('.jdgm-rev')];
    const photos = [];
    reviews.forEach((rev) => {
      const rating = parseInt(rev.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'), 10) || 0;
      const review = {
        author: text(rev.querySelector('.jdgm-rev__author')),
        title: text(rev.querySelector('.jdgm-rev__title')),
        body: text(rev.querySelector('.jdgm-rev__body')),
        rating,
      };
      rev.querySelectorAll('.jdgm-rev__pic-link').forEach((link) => {
        const src = link.getAttribute('href') || link.getAttribute('data-mfp-src');
        if (src) photos.push({ src, review });
      });
    });
    return { count: reviews.length, photos };
  }

  async function fetchPhotos(productId) {
    const shop = shopDomain();
    if (!shop) return [];
    const photos = [];
    const seen = new Set();
    let loaded = 0;
    for (let page = 1; page <= MAX_PAGES; page++) {
      const params = new URLSearchParams({ url: shop, shop_domain: shop, platform: 'shopify', page, per_page: PER_PAGE, product_id: productId });
      const response = await fetch(`https://cdn.judge.me/reviews/reviews_for_widget?${params}`);
      if (!response.ok) break;
      const data = await response.json();
      const result = parseReviews(data.html || '');
      result.photos.forEach((photo) => {
        if (seen.has(photo.src)) return;
        seen.add(photo.src);
        photos.push(photo);
      });
      loaded += result.count;
      if (result.count === 0 || loaded >= (data.total_count || 0)) break;
    }
    return photos;
  }

  function stars(rating) {
    const wrap = document.createElement('span');
    wrap.className = 'review-photos__stars';
    wrap.setAttribute('aria-label', `${rating} out of 5 stars`);
    wrap.textContent = '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(0, 5 - rating);
    return wrap;
  }

  function buildLightbox(photos) {
    const dialog = document.createElement('dialog');
    dialog.className = 'review-photos__dialog';
    dialog.innerHTML = `
      <button type="button" class="review-photos__close" aria-label="Close">&times;</button>
      <button type="button" class="review-photos__nav review-photos__nav--prev" aria-label="Previous photo">&#8249;</button>
      <figure class="review-photos__figure">
        <img class="review-photos__image" alt="">
        <figcaption class="review-photos__caption"></figcaption>
      </figure>
      <button type="button" class="review-photos__nav review-photos__nav--next" aria-label="Next photo">&#8250;</button>
    `;
    const img = dialog.querySelector('.review-photos__image');
    const caption = dialog.querySelector('.review-photos__caption');
    const prev = dialog.querySelector('.review-photos__nav--prev');
    const next = dialog.querySelector('.review-photos__nav--next');
    let current = 0;

    function show(index) {
      current = (index + photos.length) % photos.length;
      const { src, review } = photos[current];
      img.src = sizedUrl(src, 1024);
      img.alt = review.author ? `Customer photo from ${review.author}` : 'Customer photo';
      caption.replaceChildren();
      if (review.rating) caption.append(stars(review.rating));
      if (review.author) { const p = document.createElement('p'); p.className = 'review-photos__author'; p.textContent = review.author; caption.append(p); }
      if (review.title) { const p = document.createElement('p'); p.className = 'review-photos__title'; p.textContent = review.title; caption.append(p); }
      if (review.body) { const p = document.createElement('p'); p.className = 'review-photos__body'; p.textContent = review.body; caption.append(p); }
    }

    const single = photos.length < 2;
    prev.hidden = single;
    next.hidden = single;
    prev.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    dialog.querySelector('.review-photos__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (event) => {
      if (single) return;
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
    return { element: dialog, open(index) { show(index); dialog.showModal(); } };
  }

  function buildStrip(photos) {
    const strip = document.createElement('div');
    strip.className = STRIP_CLASS;
    const heading = document.createElement('p');
    heading.className = 'review-photos__heading';
    heading.textContent = 'Customer photos';
    const list = document.createElement('ul');
    list.className = 'review-photos__list';
    const lightbox = buildLightbox(photos);

    photos.forEach((photo, index) => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'review-photos__thumb';
      button.setAttribute('aria-label', photo.review.author ? `View photo from ${photo.review.author}'s review` : 'View customer photo');
      const img = document.createElement('img');
      img.src = sizedUrl(photo.src, 300);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 150;
      img.height = 150;
      button.append(img);
      button.addEventListener('click', () => lightbox.open(index));
      item.append(button);
      list.append(item);
    });

    const track = document.createElement('div');
    track.className = 'review-photos__track';
    const arrow = (direction, label, symbol) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `review-photos__arrow review-photos__arrow--${direction}`;
      button.setAttribute('aria-label', label);
      button.innerHTML = symbol;
      button.addEventListener('click', () => {
        const step = list.clientWidth * 0.8 * (direction === 'prev' ? -1 : 1);
        list.scrollBy({ left: step, behavior: 'smooth' });
      });
      return button;
    };
    const prevArrow = arrow('prev', 'Previous photos', '&#8249;');
    const nextArrow = arrow('next', 'More photos', '&#8250;');
    const updateArrows = () => {
      const max = list.scrollWidth - list.clientWidth;
      prevArrow.hidden = list.scrollLeft <= 1;
      nextArrow.hidden = list.scrollLeft >= max - 1;
    };
    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    new ResizeObserver(updateArrows).observe(list);
    track.append(prevArrow, list, nextArrow);
    strip.append(heading, track);
    document.body.append(lightbox.element);
    return strip;
  }

  function currentWidget(container) { return container.querySelector(WIDGET_SELECTOR); }

  function place(container, strip) {
    if (strip.isConnected) return;
    const widget = currentWidget(container);
    if (!widget || !widget.querySelector('.jdgm-rev-widg__header')) return;
    const anchor = widget.querySelector('.jdgm-row-media') || widget.querySelector('.jdgm-row-actions');
    if (!anchor) return;
    anchor.parentNode.insertBefore(strip, anchor);
  }

  async function init(container, productId) {
    const photos = await fetchPhotos(productId).catch(() => []);
    if (!photos.length) return;
    const strip = buildStrip(photos);
    place(container, strip);
    new MutationObserver(() => place(container, strip)).observe(container, { childList: true, subtree: true });
  }

  function setup() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!widget) return;
    const productId = widget.getAttribute('data-product-id');
    const container = widget.closest('.shopify-block') || widget.parentElement;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); init(container, productId); }
    }, { rootMargin: '600px 0px' });
    observer.observe(container);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
